<template>
    <div id="container">
        <span v-if="showExpiredTimeError" class="notify-window" v-html="$t('kollus_player.notify_message.jwt_expired_time')"></span>
        <div v-else class="background-poster" :style="'background-image: url(' + playerPolicy.poster_url + ');'" @click="runApplication">
            <div id="placeholder">
                <div id="wrapper">
                    <button class="background-play-button" type="button" aria-live="polite" title="Play Video" aria-disabled="false"></button>
                </div>
            </div>
        </div>
        <iframe id="hiddenIframe" v-if="scheme" :src="scheme"></iframe>
        <template v-if="showNotifyBar">
            <div @click="hideAppInstallationGuideNotifyBar" id="player-installation-notify-bar" class="alert alert-mobile bounce-effect hide">
                <p v-html="$t('kollus_player.notify_message.mobile.install_guide')">
                    <i class="icon-alert"></i>
                </p>
                <button class="btn btn-success" tabIndex="-1" @click="installApplication">
                    <span v-html="$t('kollus_player.notify_message.mobile.install_button')"></span>
                    <i class="icon-right-open"></i>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
import loadJsCss from "load-js-css";

export default {
    name: 'kollus-player-mobile',
    props: {
        playerPolicy: {
            type: Object,
            required: true,
        },
        mediaInfoString: {
            type: String,
            required: true,
        },
        expireTime: {
            type: String,
        },
    },
    data() {
        return {
            playerConfig: this.playerPolicy.player_config.mobile,
            showNotifyBar: false,
            showExpiredTimeError: false,
            scheme: '',
        }
    },
    beforeMount() {
        loadJsCss.list(this.playerConfig.resources);
    },
    mounted() {
        let external_loader = setInterval(() => {
            if (window.Kollus && window.Kollus.vgControllerPlayer) {
                clearInterval(external_loader);

                this.vgControllerPlayer = window.Kollus.vgControllerPlayer(this.runApplication);

                let controller = new VgControllerServer(this.vgControllerPlayer, {
                    player_type: 'kollus',
                    target_window: window.parent,
                });
                controller.setEventListeners(this.vgControllerPlayer);

                this.vgControllerPlayer.trigger('kollus_ready');

                if (this.playerPolicy.autostart) {
                    this.runApplication();
                }
            }
        }, 10);
    },
    methods: {
        validateExpiretime: (value) => {
            return (Date.now()/1000) < value * 1;
        },
        showAppInstallationGuideNotifyBar() {
            setTimeout(() => {
                const hasFocus = typeof window.document.hasFocus !== 'undefined' && !navigator.userAgent.match(/Safari/i) ? window.document.hasFocus() : true;
                if (hasFocus) {
                    // 어플리케이션 설치 notify bar
                    this.showNotifyBar = true;
                }
            }, 1500);
        },
        hideAppInstallationGuideNotifyBar() {
            this.showNotifyBar = false;
        },
        installApplication() {
            window.top.location.href = (this.playerPolicy.os.name === 'iOS') ?
                'https://itunes.apple.com/us/app/kollusplayer/id760006888?l=ko&ls=1&mt=8' :
                'market://details?id=com.kollus.media'; //'https://play.google.com/store/apps/details?id=com.kollus.media';
        },
        runApplication() {
            if (this.validateExpiretime(this.expireTime)) {
                const OS = this.playerPolicy.os;
                const USERAGENT_LOWERCASE = navigator.userAgent.toLocaleLowerCase();
                const SCHEME_GENERAL_URI = this.playerConfig.scheme.general;
                const SCHEME_INTENT_URI = this.playerConfig.scheme.intent;

                if (OS.name == 'iOS') {
                    // 플레이어 미설치시 앱스토어로 리다이렉션
                    this.showAppInstallationGuideNotifyBar();

                    // ios 9.0의 safari 체크
                    // ios 9.0의 safari는 iframe의 schema link를 감지하지 못함
                    // 따라서 ios 9.0 이하의  사파리 버전 (600.1.4 이하) 과 9.0 이상의 사파리 버전 (601.1) 을 구분하여
                    // 이하는 기존 방식대로 앱을 호출하고
                    // 이상은 직접 location.href 값을 변경하여 앱을 호출하도록 한다.
                    const SAFARI_VERSION = parseFloat(USERAGENT_LOWERCASE.substr(USERAGENT_LOWERCASE.lastIndexOf('safari/') + 7, 7));
                    if (SAFARI_VERSION >= 601.1) {
                        window.top.location.href = SCHEME_GENERAL_URI;
                    } else {
                        this.scheme = SCHEME_GENERAL_URI + this.addUnixTimestamp(SCHEME_GENERAL_URI);
                    }
                } else {
                    const CHROME25 = USERAGENT_LOWERCASE.search('chrome') > -1 && navigator.appVersion.match(/Chrome\/\d+.\d+/)[0].split('/')[1] > 25;

                    // chrome25 버전 이하는 iframe의 src에 general schema link를 주입하고
                    // 이상 버전은 intent 링크를 사용
                    // 이때 kitkat webview에서는 chrome25 이하 버전과 동일하게 동작함
                    if (CHROME25 && !this.playerPolicy.isDaumNaverKitKatWebView) {
                        // vg가 iframe 내부로 호출된 경우 intent call을 vg-controller를 통해서 실행한다.
                        if (window.self !== window.top && this.vgControllerPlayer.getClientVersion()) {
                            this.vgControllerPlayer.trigger('kollus_call_intent_uri', SCHEME_INTENT_URI);
                        } else {
                            window.top.location.href = SCHEME_INTENT_URI;
                        }
                    } else {
                        // 플레이어 미설치시 앱스토어로 자동으로 리다이렉션
                        this.showAppInstallationGuideNotifyBar();

                        this.scheme = SCHEME_GENERAL_URI + this.addUnixTimestamp(SCHEME_GENERAL_URI);
                    }
                }
            } else {
                this.showExpiredTimeError = true;
                this.vgControllerPlayer.trigger('kollus_error', {code: 4085, message: this.$i18n.t('kollus_player.notify_message.jwt_expired_time')});
            };
        },
        addUnixTimestamp(uri) {
            let separator = uri ? (uri.indexOf('?') !== -1 ? '&' : '?') : '?';
            return separator + 'timestamp=' + Math.floor(new Date().getTime() / 1000);
        },
    },
}
</script>

<style scoped>
    .background-poster {
        display: inline-block;
        vertical-align: middle;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        background-size: contain;
        background-color: #000000;
        cursor: pointer;
        margin: 0;
        padding: 0;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        height: 100%;
    }

    .background-play-button {
        font-size: 12px;
        color: #fff;
        background: 0;
        border: 5px solid #fff;
        border-radius: 100em;
        height: 100px;
        line-height: 100px -5px;
        margin: 0;
        width: 100px;
        pointer-events: auto;
        cursor: pointer;
        outline: none;
        display: inline-block;
        -webkit-box-shadow: inset 0 0 10px 2px rgba(0, 0, 0, 0.3), 0 0 10px 2px rgba(0, 0, 0, 0.2);
        -moz-box-shadow: inset 0 0 10px 2px rgba(0, 0, 0, 0.3), 0 0 10px 2px rgba(0, 0, 0, 0.2);
        box-shadow: inset 0 0 10px 2px rgba(0, 0, 0, 0.3), 0 0 10px 2px rgba(0, 0, 0, 0.2);
    }

    .background-play-button:before {
        font-size: 3em;
        margin-left: 10px;
        text-shadow: 0 0 10px rgba(0, 0, 0, .6);
        content: '\e800';
        font-family: "icon-v4";
    }

    .notify-window {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    video::-internal-media-controls-download-button {
        display: none;
    }

    video::-webkit-media-controls-enclosure {
        overflow: hidden;
    }

    video::-webkit-media-controls-panel {
        width: calc(100% + 40px); /* Adjust as needed */
    }
</style>
